import React from "react";
import { Routes as ReactRoutes, Route } from "react-router-dom";

import Header from "../components/header/index.jsx";
import AppLayout from "../layouts/AppLayout.jsx";
import BaseLayout from "../layouts/BaseLayout.jsx";
import Login from "../layouts/Login";
import Logout from "../layouts/Logout.jsx";
// Modules
import ArriVideoBroadcastEditor from "../modules/arriVideo/components/broadcasts/BroadcastEditor.jsx";
import ArriVideoContentItemEditor from "../modules/arriVideo/components/contentItems/ContentItemEditor.jsx";
import ArriVideoDashboard from "../modules/arriVideo/components/Dashboard.jsx";
import ArriVideoFolderEditor from "../modules/arriVideo/components/folders/FolderEditor.jsx";
import EmailEstablishmentDashboard from "../modules/emailAddressEstablishment/components/Dashboard.jsx";
import EstablishmentEditor from "../modules/emailAddressEstablishment/components/EstablishmentEditor.jsx";
import CategoryEditor from "../modules/malfunctions/components/Categories/CategoryEditor.jsx";
import MalfunctionsDashboard from "../modules/malfunctions/components/Dashboard.jsx";
import MalfunctionsEditor from "../modules/malfunctions/components/Malfunctions/MalfunctionsEditor.jsx";
import MalfunctionsList from "../modules/malfunctions/components/Malfunctions/MalfunctionsList.jsx";
import MalfunctionConfirmation from "../modules/malfunctions/components/Malfunctions/public/Confirmation.jsx";
import Confirmation from "../modules/malfunctions/components/Malfunctions/public/Confirmation.jsx";
import OpenMalfunctionsEditor from "../modules/malfunctions/components/Malfunctions/public/OpenMalfunctionsEditor.jsx";
import OpenMalfunctionsList from "../modules/malfunctions/components/Malfunctions/public/OpenMalfunctionsList.jsx";
import Dashboard from "../modules/settings/components/Dashboard.jsx";
import SoftwareNotificationDashboard from "../modules/softwareNotifications/components/Dashboard.jsx";
import SoftwareNotificationEditor from "../modules/softwareNotifications/components/SoftwareNotificationEditor.jsx";
import SoftwarePackageDashboard from "../modules/softwarePackages/components/Dashboard.jsx";
import SoftwarePackageEditor from "../modules/softwarePackages/components/SoftwarePackageEditor.jsx";
import SupportLayout from "../modules/support/Support.jsx";
import TabletRegistration from "../modules/tabletRegistration/components/TabletRegistration.jsx";
import TabletRegistrationLanding from "../modules/tabletRegistration/components/TabletRegistrationLanding.jsx";
import SignalImagesDashboard from "../modules/trainStopSignalImages/components/Dashboard.jsx";
import SignalImageEditor from "../modules/trainStopSignalImages/components/SignalImageEditor.jsx";
import UrlEntryDashBoard from "../modules/urlEntry/components/Dashboard.jsx";
import UrlEntryEditor from "../modules/urlEntry/components/UrlEntryEditor.jsx";
import UserNotificationsDashboard from "../modules/userNotifications/components/Dashboards.jsx";
import UserNotificationEditor from "../modules/userNotifications/components/UserNotificationEditor.jsx";
import VehicleStatusList from "../modules/vehicleStatus/VehicleStatusList.jsx";
import VehicleWashStatusList from "../modules/vehicleWashStatus/VehicleWashStatusList.jsx";

import PrivateRoute from "./PrivateRoute.jsx";

const Routes = () => {
  return (
    <AppLayout Header={Header}>
      <ReactRoutes>
        <Route path="/" element={<PrivateRoute element={<BaseLayout />} />} />

        {/* ARRIVIDEO routes */}
        <Route
          path="/arrivideo"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={ArriVideoDashboard} />}
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/arrivideo/broadcast/add"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={ArriVideoBroadcastEditor} />}
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/arrivideo/broadcast/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={ArriVideoBroadcastEditor} />}
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/arrivideo/contentitem/add"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={ArriVideoContentItemEditor} />
              }
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/arrivideo/contentitem/edit/:identifier"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={ArriVideoContentItemEditor} />
              }
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/arrivideo/folder/add"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={ArriVideoFolderEditor} />}
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/arrivideo/folder/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={ArriVideoFolderEditor} />}
              resourceType="ARRIVIDEO"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* TABLET REGISTRATION routes */}
        <Route
          path="/tablet-registration"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={TabletRegistrationLanding} />
              }
              resourceType="TABLET_REGISTRATION"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/tablet-registration/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={TabletRegistration} />}
              resourceType="TABLET_REGISTRATION"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* URLENTRY routes */}
        <Route
          path="/url-entry"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={UrlEntryDashBoard} />}
              resourceType="URLENTRY"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/url-entry/url-entry/add"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={UrlEntryEditor} />}
              resourceType="URLENTRY"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/url-entry/url-entry/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={UrlEntryEditor} />}
              resourceType="URLENTRY"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* USER SoftwareNotifications */}
        <Route
          path="/notifications"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={UserNotificationsDashboard} />
              }
              resourceType="USER_NOTIFICATIONS"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/notifications/notification/add"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={UserNotificationEditor} />}
              resourceType="USER_NOTIFICATIONS"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/notifications/notification/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={UserNotificationEditor} />}
              resourceType="USER_NOTIFICATIONS"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* SOFTWARE PACKAGE */}
        <Route
          path="/software-package"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SoftwarePackageDashboard} />}
              resourceType="SOFTWARE_PACKAGE"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/software-package/package/add"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SoftwarePackageEditor} />}
              resourceType="SOFTWARE_PACKAGE"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/software-package/package/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SoftwarePackageEditor} />}
              resourceType="SOFTWARE_PACKAGE"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* SOFTWARE NOTIFICATIONS */}
        <Route
          path="/message"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={SoftwareNotificationDashboard} />
              }
              resourceType="SOFTWARE_PACKAGE"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/message/package-notification/add"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={SoftwareNotificationEditor} />
              }
              resourceType="SOFTWARE_PACKAGE"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/message/package-notification/edit/:identifier"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={SoftwareNotificationEditor} />
              }
              resourceType="SOFTWARE_PACKAGE"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* SIGNAL IMAGES */}
        <Route
          path="/signal-image"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SignalImagesDashboard} />}
              resourceType="MACHINIST"
              resourceKey="isTrainStopSignalImageAdministrator"
            />
          }
        />
        <Route
          path="/signal-image/find"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SignalImagesDashboard} />}
              resourceType="MACHINIST"
              resourceKey="isTrainStopSignalImageAdministrator"
            />
          }
        />
        <Route
          path="/signal-image/find/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SignalImagesDashboard} />}
              resourceType="MACHINIST"
              resourceKey="isTrainStopSignalImageAdministrator"
            />
          }
        />
        <Route
          path="/signal-image/add/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SignalImageEditor} />}
              resourceType="MACHINIST"
              resourceKey="isTrainStopSignalImageAdministrator"
            />
          }
        />
        <Route
          path="/signal-image/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={SignalImageEditor} />}
              resourceType="MACHINIST"
              resourceKey="isTrainStopSignalImageAdministrator"
            />
          }
        />
        {/* EMAIL-ADDRESS ESTABLISHMENT */}
        <Route
          path="/email-establishment"
          element={
            <PrivateRoute
              element={
                <BaseLayout childComponent={EmailEstablishmentDashboard} />
              }
              resourceType="EMAIL_ESTABLISHMENT"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/email-establishment/establishment/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={EstablishmentEditor} />}
              resourceType="EMAIL_ESTABLISHMENT"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* MALFUNCTIONS */}
        <Route
          path="/malfunction-form"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={MalfunctionsDashboard} />}
              resourceType="MALFUNCTIONS"
              resourceKey="write"
            />
          }
        />
        <Route
          path="/malfunctions/categories"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={MalfunctionsList} />}
              resourceType="MALFUNCTIONS"
              resourceKey="read"
            />
          }
        />
        <Route
          path="/malfunctions/categories/add"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={CategoryEditor} />}
              resourceType="MALFUNCTIONS"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/malfunctions/categories/edit/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={CategoryEditor} />}
              resourceType="MALFUNCTIONS"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/malfunctions/pending-malfunctions/add/:identifier"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={MalfunctionsEditor} />}
              resourceType="MALFUNCTIONS"
              resourceKey="isAdministrator"
            />
          }
        />
        <Route
          path="/malfunctions/malfunctions-confirmation"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={MalfunctionConfirmation} />}
              resourceType="MALFUNCTIONS"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* SETTINGS */}
        <Route
          path="/settings"
          element={
            <PrivateRoute
              element={<BaseLayout childComponent={Dashboard} />}
              resourceType="SETTINGS"
              resourceKey="isAdministrator"
            />
          }
        />

        {/* Public routes */}
        <Route
          path="/vehicle-status/:identifier"
          element={<VehicleStatusList />}
        />
        <Route
          path="/vehicle-wash-status/:identifier"
          element={<VehicleWashStatusList />}
        />
        <Route
          path="/malfunctions/open/:identifier"
          element={<OpenMalfunctionsList />}
        />
        <Route
          path="/malfunctions/open-internal/:identifier"
          element={<OpenMalfunctionsList />}
        />
        <Route
          path="/malfunctions/open-route/confirmation"
          element={<Confirmation />}
        />
        <Route
          path="/malfunctions/open/pending-malfunctions/add/:identifier"
          element={<OpenMalfunctionsEditor />}
        />
        <Route path="/logout" element={<Logout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/support" element={<SupportLayout />} />
      </ReactRoutes>
    </AppLayout>
  );
};

export default Routes;
